import { useBiddingDetailDispatch } from './bidding-detail-context';
import PortalAppService from '../../../application/platform/portal-app-service';

export function useBiddingDetailController() {
  const dispatch = useBiddingDetailDispatch();

  const loadDetail = async (id: number) => {
    dispatch({ type: 'LOAD_START' });

    try {
      const response = await PortalAppService.getBiddingDetail(id);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar detalhes da licitação';
      dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
    }
  };

  return {
    loadDetail,
  };
}
